var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"fixed","top":"0","left":"0","right":"0","bottom":"0","background-color":"rgba(0, 0, 0, 0.7)","z-index":"5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }